import { createContext } from 'react'

export interface MessagePin {
  isSelectedAgent: boolean,
  color: string,
  id: string,
  width: number,
  numLines: number,
  timestampInChatMs: number,
  participantName: string,
}

export interface Participant {
  id: number,
  role: string,
  externalId: string,
  label: string,
}

export interface Message {
  id: string,
  body: string,
  authorId: number,
  sendTimeMs: number,
}

export interface Chat {
  text: {
    data: {
      chatBody: {
        startTimeMs: number,
        messages: Message[],
        participants: Participant[],
      },
    },
  },
}

export interface IndexedChatBubble {
  index: number,
  authorName: string,
  relativeTimestampMs: number,
}

export interface SelectedChatBubbleContextType {
  selectedBubbleId: number | null,
  setSelectedBubbleId: React.Dispatch<React.SetStateAction<number | null>>,
}

/**
 * Context to store the selected chat bubble. This is used to highlight the selected bubble in the chat map and to
 * assign an eval comment to a message. The default implemntatation does nothing; context provider should store state.
 */
export const SelectedChatBubbleContext = createContext<SelectedChatBubbleContextType>({ selectedBubbleId: null, setSelectedBubbleId: () => { /* noop */ } })
